var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessionalMailingAdr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 58,
    viewBox: "0 0 101 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.7019,
    y: 9.92993,
    width: 68.2932,
    height: 48.0701,
    rx: 1.54578,
    fill: "#FEDE73"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_385_2593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.946 6.5119V52.6404L27.2373 52.6416V6.51311",
    stroke: "black",
    strokeWidth: 2.58868,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2373 6.51364L61.5925 33.4739L95.946 6.51364H27.2373Z",
    stroke: "black",
    strokeWidth: 2.58868,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2373 52.6422L56.6292 29.5771",
    stroke: "black",
    strokeWidth: 2.58868,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.946 52.6405L66.5576 29.5771",
    stroke: "black",
    strokeWidth: 2.58868,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2348 10.9299H2.1792",
    stroke: "black",
    strokeWidth: 2.58868,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2348 35.7933H10.7058",
    stroke: "black",
    strokeWidth: 2.58868,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2348 23.3608L14.9709 23.3596",
    stroke: "black",
    strokeWidth: 2.58868,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9704 23.359L6.44263 23.3602",
    stroke: "black",
    strokeWidth: 2.58868,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2348 48.2224L14.9685 48.2236",
    stroke: "black",
    strokeWidth: 2.58868,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_385_2593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.6132,
    height: 49,
    fill: "white",
    transform: "translate(0.693359 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalMailingAdr);
export default __webpack_public_path__ + "static/media/ProfessionalMailingAdr.dc51b341923edda3d19d766e519f4371.svg";
export { ForwardRef as ReactComponent };